import { cn } from '@/utils/cn'
import { type IconProps, iconVariants } from './common'

export function ExternalLinkIcon({ className, size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M18.9213 5.13465C18.9128 5.1251 18.9039 5.11577 18.8947 5.10664C18.7591 4.97095 18.5715 4.88695 18.3644 4.88702H14.1218C13.7076 4.88702 13.3718 5.22275 13.3718 5.63697C13.3718 6.0512 13.7076 6.38693 14.1218 6.38693L16.5537 6.387L5.10616 17.8346C4.81327 18.1275 4.81328 18.6023 5.10616 18.8952C5.39905 19.1881 5.87393 19.1881 6.16682 18.8952L17.6144 7.44766L17.6144 9.87959C17.6144 10.2938 17.9502 10.6296 18.3644 10.6296C18.7787 10.6296 19.1144 10.2939 19.1144 9.87964L19.1144 5.63697C19.1144 5.53529 19.0942 5.43828 19.0575 5.34989C19.0256 5.27267 18.9802 5.1997 18.9213 5.13465Z"
        fill="currentColor"
      />
    </svg>
  )
}
